import {
  Component,
  OnInit,
  HostListener,
  computed,
  OnDestroy
} from '@angular/core'
import { Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { NotificationService } from 'src/app/modules/notification/services/notification.service'
import { SidenavService } from '../../services/sidenav.service'
import { CompanyProfileService } from 'src/app/modules/company-profile/services/company-profile.service'
import { LayoutService } from 'src/app/core/services/layout.service'

import { RouterModule } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { MatMenuModule } from '@angular/material/menu'
import { MatBadgeModule } from '@angular/material/badge'
import { MatButtonModule } from '@angular/material/button'
import { LocalizedDatePipe } from '../../pipes/localized-date.pipe'
import { HtmlToTextPipe } from '../../pipes/html-to-text.pipe'
import { DropdownToggleDirective } from '../../directives/dropdown-toggle.directive'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    TranslatePipe,
    MatMenuModule,
    MatBadgeModule,
    MatButtonModule,
    LocalizedDatePipe,
    HtmlToTextPipe,
    DropdownToggleDirective
  ]
})
export class HeaderComponent implements OnInit, OnDestroy {
  user: any = localStorage.getItem('user')
  userMail: any = localStorage.getItem('userMail')
  // notifications: any[] = [];
  unReadNotifications: any[] = []
  currentLanguage = localStorage.getItem('lang')
  screenWidth: number = 0
  showMobileMenuButton: boolean = false
  private alive: boolean = true
  companyInfo!: any
  companyProfileSignal: any
  notifications
  unreadCount
  refreshIntervalId: any

  constructor(
    private router: Router,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private sidenavService: SidenavService,
    private companyProfileService: CompanyProfileService,
    private layout: LayoutService
  ) {
    this.notifications = computed(() =>
      this.notificationService.menuNotifications()
    )
    this.unreadCount = this.notificationService.unreadCount
    this.companyProfileSignal = this.companyProfileService.companyProfileSignal
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth
    this.checkScreenSize()
    this.user = JSON.parse(this.user)
    this.companyProfileService.getCompanyProfile().subscribe()

    this.initNotifications()
  }

  initNotifications(): void {
    this.notificationService.requestPermission()
    this.notificationService.listenForMessages()

    this.notificationService.getMenuNotifications()
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = event.target.innerWidth
    this.checkScreenSize()
  }

  checkScreenSize() {
    this.showMobileMenuButton = this.screenWidth < 769
  }

  toggleMobileMenu() {
    this.sidenavService.toggleMobileMenu()
  }

  // GRC theme: one hamburger drives the mobile drawer below 769px and the
  // desktop sidebar collapse above it (same behavior as the classic in-sidebar
  // chevron, via the shared LayoutService signal).
  onHamburgerClick() {
    if (this.screenWidth < 769) {
      this.sidenavService.toggleMobileMenu()
    } else {
      this.layout.toggleSidebar()
    }
  }

  // Fallback initials for the GRC-theme avatar chips.
  get userInitial(): string {
    return (this.user?.username || '?').trim().charAt(0).toUpperCase()
  }

  get tenantInitial(): string {
    const profile = this.companyProfileSignal()
    const name =
      (this.currentLanguage === 'ar' ? profile?.nameAr : profile?.name) ||
      profile?.name ||
      ''
    return name.trim().charAt(0).toUpperCase() || '?'
  }

  changeLang() {
    this.currentLanguage = this.currentLanguage === 'ar' ? 'en' : 'ar'
    this.translate.use(this.currentLanguage)
    localStorage.setItem('lang', this.currentLanguage)
    document
      .getElementsByTagName('html')[0]
      .setAttribute('dir', this.currentLanguage === 'ar' ? 'rtl' : 'ltr')
    document
      .getElementsByTagName('body')[0]
      .setAttribute('dir', this.currentLanguage === 'ar' ? 'rtl' : 'ltr')
    location.reload()
  }

  gotoDetails(item: any) {
    this.notificationService.readNotification(item.id)
    if (item.notificationType === 1) {
      this.router.navigate(['/risks/details', item.messageId])
    } else if (item.notificationType === 2) {
      this.router.navigate(['/treatments'])
    } else {
      return
    }
  }

  ngOnDestroy(): void {
    if (this.refreshIntervalId) clearInterval(this.refreshIntervalId)
  }
}
